module.exports = __webpack_public_path__ + "img/benchmarks-card-blur.72424c42.png";